import { Checkbox, Form } from 'antd';
import classNames from 'classnames';
import set from 'lodash/set';
import PropTypes from 'prop-types';
import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import InfoBox from '@/components/InfoBox';
import RequiredText from '@/components/RequiredText/RequiredText';
import UploadFileDragger from '@/components/UploadFileDragger';
import ModelProposalDownload from '@/modules/proposalRequest/components/ModelProposalDownload';
import { MODELS_FILE_KEYS } from '@/modules/proposalRequest/contants/proposalRequest';

const RepresentativeAval = ({ value, onChange, label, translate, useUpload, ...rest }) => {
  const { t } = useTranslation(translate || 'common');
  let [data, setData] = useState(value || {});
  const [form] = Form.useForm();
  const upload = useRef();

  useEffect(() => {
    if (value) {
      setData(value || {});
    }
  }, [value]);
  
  const onChangeValue = useCallback((value, key) => {
    set(data, key, value);
    setData({ ...data });
    onChange && onChange({ ...data });
  }, [data, onChange]);
  
  const onActiveChange = useCallback((e) => {
    onChangeValue(e?.target?.checked, 'active');
    if (!e?.target?.checked) {
      onChangeValue(null, 'file');
      form.resetFields();
    }
  }, [form, onChangeValue]);
  
  const onFileChange = useCallback((e) => {
    onChangeValue(e, 'file');
  }, [onChangeValue]);
  
  return (
    <div {...rest}>
      <Checkbox
        checked={data?.active}
        className={classNames('mx-0 my-px')}
        size={'large'}
        onChange={onActiveChange}>
        <span onClick={() => onActiveChange({ target: { checked: !data?.active } })}>
          <RequiredText value={t(label)} required className="mb-0 cursor-pointer"/>
        </span>
      </Checkbox>
      {!!data?.active && useUpload && <div className="mt-2">
        <UploadFileDragger
          value={data?.file}
          disabled={!data?.active}
          isImage={false}
          translation={translate}
          innerRef={upload}
          listType={'picture'}
          onChange={onFileChange}
          maxCount={1}
          descriptionText={'signup.isRepresentative.upload'}/>
        <InfoBox title={'proposalRequest.form.general.statutes.help'} translate={'proposalRequest'}
          action={<ModelProposalDownload identifier={MODELS_FILE_KEYS.MODELO_CARTA_SOCIO_DESIGNADO}/>}/>
      </div>}
    </div>
  );
};

RepresentativeAval.propTypes = {
  value: PropTypes.object,
  useUpload: PropTypes.bool,
  translate: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func
};

RepresentativeAval.defaultProps = {
  useUpload: true
};

export default memo(RepresentativeAval);
